import React from 'react';

const scoreRingStyles = {
  wrap: {
    position: 'relative', display: 'inline-flex',
    alignItems: 'center', justifyContent: 'center',
  },
  center: {
    position: 'absolute',
    width: '104px', height: '104px', borderRadius: '50%',
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    transition: 'background-color 0.6s',
  },
  scoreNum: {
    fontFamily: 'var(--font-heading)', fontSize: '36px',
    fontWeight: 800, lineHeight: 1,
  },
  scoreUnit: { fontSize: '15px', fontWeight: 700, color: 'var(--color-text-secondary)', lineHeight: 1, marginTop: '2px' },
  scoreLabel: { fontSize: '10px', color: 'var(--color-text-muted)', fontWeight: 600, marginTop: '4px', letterSpacing: '0.04em', textTransform: 'uppercase', textAlign: 'center' },
};

const ScoreRing = ({ score }) => {
  const radius = 64;
  const circumference = 2 * Math.PI * radius; // ~339.29
  const offset = circumference - (score / 100) * circumference;

  const ringColor =
    score >= 80 ? 'var(--color-success)' :
      score >= 60 ? 'var(--color-warning)' :
        'var(--color-error)';

  const bgColor =
    score >= 80 ? 'var(--color-success-bg)' :
      score >= 60 ? 'var(--color-warning-bg)' :
        'var(--color-error-bg)';

  return (
    <div style={scoreRingStyles.wrap}>
      <svg width="160" height="160" viewBox="0 0 160 160" aria-label={`Overall match score: ${score}%`} role="img">
        {/* Track */}
        <circle cx="80" cy="80" r={radius}
          fill="none" stroke="var(--color-border)" strokeWidth="10" />
        {/* Progress */}
        <circle cx="80" cy="80" r={radius}
          fill="none" stroke={ringColor} strokeWidth="10"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform="rotate(-90 80 80)"
          style={{
            transition: 'stroke-dashoffset 1.2s cubic-bezier(0.4, 0, 0.2, 1)',
            filter: `drop-shadow(0 0 6px ${ringColor}60)`,
          }}
        />
      </svg>
      {/* Center text */}
      <div style={{ ...scoreRingStyles.center, backgroundColor: bgColor }}>
        <span style={{ ...scoreRingStyles.scoreNum, color: ringColor }}>{score}</span>
        <span style={scoreRingStyles.scoreUnit}>%</span>
        <span style={scoreRingStyles.scoreLabel}>Overall Match</span>
      </div>
    </div>
  );
};

export default ScoreRing;
